const state = {
  constant: null,
  language: localStorage.getItem('language') || 'vi',
  accountOrg: null,
  reloadConstant: null,
  iamActions: null
}

const getters = {
  constant(state) {
    return state.constant
  },
  language(state) {
    return state.language || 'vi'
  },
  accountOrg(state) {
    return state.accountOrg
  },
  reloadConstant(state) {
    return state.reloadConstant
  },
  iamActions(state) {
    return state.iamActions
  }
}

const mutations = {
  UPDATE_CONSTANT(state, constant) {
    state.constant = constant
  },
  UPDATE_LANGUAGE(state, language) {
    const lang = language || 'vi'
    state.language = lang
    localStorage.setItem('language', lang)
  },
  UPDATE_ACCOUNT_ORG(state, accountOrg) {
    state.accountOrg = accountOrg
  },
  UPDATE_RELOAD_CONSTANT(state, reloadConstant) {
    state.reloadConstant = reloadConstant
  },
  UPDATE_IAM_ACTIONS(state, iamActions) {
    state.iamActions = iamActions
  }
}

const actions = {
  updateConstant({ commit }, constant) {
    commit('UPDATE_CONSTANT', constant)
  },
  updateLanguage({ commit }, language) {
    commit('UPDATE_LANGUAGE', language)
  },
  updateAccountOrg({ commit }, accountOrg) {
    commit('UPDATE_ACCOUNT_ORG', accountOrg)
  },
  updateReloadConstant({ commit }, reloadConstant) {
    commit('UPDATE_RELOAD_CONSTANT', reloadConstant)
  },
  updateIamActions({ commit }, iamActions) {
    commit('UPDATE_IAM_ACTIONS', iamActions)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
